var map = {
	"./access-management.svg": "2dn7",
	"./administrator.svg": "TB4A",
	"./ai.svg": "0yM7",
	"./analytic.svg": "5YvL",
	"./application.svg": "bJln",
	"./data-connectivity.svg": "GsUG",
	"./data-manager.svg": "RNKE",
	"./experience-manager.svg": "GXo+",
	"./home-screen.svg": "+45w",
	"./joana.svg": "VnUW",
	"./open-tab.svg": "srwW",
	"./third-party-connection.svg": "6xAw",
	"./visual-programming.svg": "D3xo",
	"./workflow.svg": "rFfw"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "V4LS";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-sidebar ^\.\/.*\.svg$
// module id = V4LS
// module chunks = 46